import * as React from 'react';
import * as styles from './index.module.less';
import { PublicAdd, PublicMinus } from 'notta-web-icon';
import { isNumber, isNaN } from 'lodash-es';

export interface INumberStepperProps {
  defaultValue?: number;
  maximum: number;
  minimum: number;
  onChange: (value) => void;
  buttonSpan?: number;
  inputSpan?: number;
  height?: number;
  checkSeats?: (e: number) => boolean;
  changeCurrentValue?: (e: number) => void;
  disable?: boolean;
  isNeedBackground?: boolean;
}

const disableWarpper = (fn, disable) => {
  if (disable) return () => {};

  return fn;
};

const NumberStepper = (props: INumberStepperProps) => {
  const { defaultValue = 0, minimum, maximum, onChange, height = 24, disable = false, isNeedBackground = true } = props;

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const originalValue = e.target.value;
    if (originalValue === '') {
      onChange('');
      return;
    }
    let currentInput = Number(e.target.value);
    if (!isNumber(currentInput) || isNaN(currentInput)) {
      return;
    }
    if (currentInput > maximum) {
      currentInput = maximum;
    }
    onChange(currentInput);
  };

  const onInputBlur = () => {
    const numericValue = Number(defaultValue);
    if (numericValue < minimum) {
      onChange(minimum);
    } else if (numericValue > maximum) {
      onChange(maximum);
    }
  };

  const onAdd = disableWarpper(() => {
    const numericValue = Number(defaultValue);
    if (numericValue >= maximum) return;
    onChange(numericValue + 1);
  }, disable);

  const onReduce = disableWarpper(() => {
    const numericValue = Number(defaultValue);
    if (numericValue <= minimum) return;
    onChange(numericValue - 1);
  }, disable);

  return (
    <div className={styles.number_stepper_con} style={{ height }}>
      <button
        className={styles.number_stepper_left_side}
        onClick={onReduce}
        data-limit={Number(defaultValue) <= minimum}
        data-disable={disable}
      >
        <PublicMinus size="12px" color={Number(defaultValue) <= minimum ? '#E0E3E5' : '#7E858C'} />
      </button>
      <div className={styles.number_stepper_center_side} data-need-background={isNeedBackground}>
        <input
          value={defaultValue}
          onInput={onInputChange}
          onChange={onInputChange}
          onBlur={onInputBlur}
          disabled={disable}
        />
      </div>
      <button
        className={styles.number_stepper_right_side}
        onClick={onAdd}
        data-limit={Number(defaultValue) >= maximum}
        data-disable={disable}
      >
        <PublicAdd size="12px" color={Number(defaultValue) >= maximum ? '#E0E3E5' : '#7E858C'} />
      </button>
    </div>
  );
};

export default NumberStepper;
